import EducationEdit from './educationEdit'
export default EducationEdit
